import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.85",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "6.7",
      height: "6.7",
      x: "3.4",
      y: "3.4",
      rx: "1.4"
    }, null, -1),
    _createElementVNode("rect", {
      width: "6.7",
      height: "6.7",
      x: "13.9",
      y: "3.4",
      rx: "1.4"
    }, null, -1),
    _createElementVNode("rect", {
      width: "6.7",
      height: "6.7",
      x: "3.4",
      y: "13.9",
      rx: "1.4"
    }, null, -1),
    _createElementVNode("rect", {
      width: "6.7",
      height: "6.7",
      x: "13.9",
      y: "13.9",
      rx: "1.4"
    }, null, -1)
  ]))]))
}
export default { render: render }